import { OnInit, TemplateRef, EventEmitter } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AdvancedFilter } from '../objects/SummaryObject';
import { SummaryService } from '../services/summary.service';
import { ViewService } from '../services/view.service';
import { ConfirmationService } from '../services/confirmation.service';
import { CustomPopupService } from '../services/custom-popup.service';
import { BodyOutputType, ToasterService } from 'angular2-toaster';
import { Toaster } from '../objects/ToasterObject';
import { ToasterMessageService } from '../services/toaster-message.service';
import { ContextMenuService, ContextMenuComponent } from 'ngx-contextmenu';
var FilteroptionComponent = /** @class */ (function () {
    function FilteroptionComponent(modalService, summaryService, viewService, confirmationService, customPopupService, toasterMessageService, toasterService, contextMenuService) {
        this.modalService = modalService;
        this.summaryService = summaryService;
        this.viewService = viewService;
        this.confirmationService = confirmationService;
        this.customPopupService = customPopupService;
        this.toasterMessageService = toasterMessageService;
        this.toasterService = toasterService;
        this.contextMenuService = contextMenuService;
        this.isCustomFilter = false;
        this.refreshSummary = new EventEmitter();
        this.refreshView = new EventEmitter();
        this.selectedItem = [];
        this.isEmptyView = false;
        this.isLoading = false;
        this.hasFilters = false;
        this.isApplyingFilter = false;
        this.applied = false;
        this.isBusy = false;
        this.refreshValue = false;
    }
    FilteroptionComponent.prototype.showFilterOptions = function (template) {
        var _this = this;
        this.isBusy = true;
        this.applied = false;
        this.summaryService.getSummaryFilterOptions(this.componentId).subscribe(function (result) {
            _this.filterOptions = JSON.parse(result);
            _this.filterOptions.forEach(function (element) {
                if (element.FilterOptionItems) {
                    _this.summaryService.CheckAdvancedSummaryFilter(_this.componentId, element.FilterField).subscribe(function (result) {
                        if (result) {
                            var advanceFilter = JSON.parse(result);
                            _this.hasFilters = true;
                            _this.filterOptions.find(function (x) { return x.FilterField == element.FilterField; }).HasAdvancedFilter = true;
                            _this.filterOptions.find(function (x) { return x.FilterField == element.FilterField; }).AdvancedFilterValue = advanceFilter.FilterValue;
                            _this.filterOptions.find(function (x) { return x.FilterField == element.FilterField; }).AdvancedFilterType = advanceFilter.FilterType;
                        }
                    });
                    if (element.FilterOptionItems.find(function (x) { return x.IsChecked == true; }) != null) {
                        _this.hasFilters = true;
                        element.SelectedFilterItem = [];
                        element.FilterOptionItems.filter(function (x) { return x.IsChecked == true; }).forEach(function (item) {
                            element.SelectedFilterItem.push(item.ItemValue);
                        });
                    }
                    else {
                        element.SelectedFilterItem = null;
                    }
                }
                element.IsDropdownOpen = false;
            });
            document.querySelector('footer').classList.add('hide');
            var config = {
                keyboard: false,
                ignoreBackdropClick: true,
                class: 'modal-dialog-centered filter-modal'
            };
            if (_this.modalService.getModalsCount() > 0) {
                document.querySelectorAll('.modal.fade').item(_this.modalService.getModalsCount() - 1).classList.remove('show');
            }
            _this.modalService.onHide.subscribe(function (reason) {
                if (_this.modalService.getModalsCount() > 0) {
                    document.querySelectorAll('.modal.fade').item(_this.modalService.getModalsCount() - 1).classList.add('show');
                }
            });
            _this.modalRef = _this.modalService.show(template, config);
            _this.modalService.onHidden.subscribe(function (reason) {
                document.querySelector('footer').classList.remove('hide');
                if (reason) {
                    if (reason == "esc") {
                        _this.changeFilter();
                    }
                }
                _this.currentFilterField = "";
            });
            _this.isBusy = false;
        }, function (error) {
            _this.isBusy = false;
        });
    };
    FilteroptionComponent.prototype.showFilterAsContextMenu = function (contextMenu, customFilter) {
        var _this = this;
        if (contextMenu === void 0) { contextMenu = null; }
        this.isBusy = true;
        this.summaryService.getSummaryFilterOptions(this.componentId).subscribe(function (result) {
            _this.filterOptions = JSON.parse(result);
            _this.filterOptions.forEach(function (element) {
                if (element.FilterOptionItems) {
                    _this.summaryService.CheckAdvancedSummaryFilter(_this.componentId, element.FilterField).subscribe(function (result) {
                        if (result) {
                            var advanceFilter = JSON.parse(result);
                            _this.hasFilters = true;
                            _this.filterOptions.find(function (x) { return x.FilterField == element.FilterField; }).HasAdvancedFilter = true;
                            _this.filterOptions.find(function (x) { return x.FilterField == element.FilterField; }).AdvancedFilterValue = advanceFilter.FilterValue;
                            _this.filterOptions.find(function (x) { return x.FilterField == element.FilterField; }).AdvancedFilterType = advanceFilter.FilterType;
                        }
                    });
                    if (element.FilterOptionItems.find(function (x) { return x.IsChecked == true; }) != null) {
                        _this.hasFilters = true;
                        element.SelectedFilterItem = [];
                        element.FilterOptionItems.filter(function (x) { return x.IsChecked == true; }).forEach(function (item) {
                            element.SelectedFilterItem.push(item.ItemValue);
                        });
                    }
                    else {
                        element.SelectedFilterItem = null;
                    }
                }
                element.IsDropdownOpen = false;
            });
            _this.contextMenuService.show.next({
                anchorElement: customFilter,
                contextMenu: _this.basicMenu,
                event: contextMenu,
                item: ''
            });
            _this.isBusy = false;
        }, function (error) {
            _this.isBusy = false;
        });
    };
    FilteroptionComponent.prototype.changeFilter = function () {
        var checkedItemsOnly = [];
        this.filterOptions.forEach(function (filterOption) {
            var filteredList = JSON.parse(JSON.stringify(filterOption));
            if (filteredList.FilterOptionItems) {
                filteredList.FilterOptionItems = filteredList.FilterOptionItems.filter(function (x) { return x.IsChecked; });
                if (filteredList.FilterOptionItems.length > 0) {
                    checkedItemsOnly.push(filteredList);
                }
            }
        });
        this.summaryService.changeFilter(this.componentId, checkedItemsOnly).subscribe(function (result) {
        });
    };
    FilteroptionComponent.prototype.getFilterOptions = function (filterField, $event) {
        var _this = this;
        document.querySelectorAll("body").item(0).style.position = "relative";
        if (this.currentFilterField != filterField) {
            this.filterOptions.find(function (x) { return x.FilterField == filterField; }).IsLoading = true;
            this.currentFilterField = filterField;
            this.summaryService.getSummaryFilterOptionList(this.componentId, filterField).subscribe(function (result) {
                var currentFilterItems = [];
                currentFilterItems = JSON.parse(result);
                _this.filterOptions.find(function (x) { return x.FilterField == filterField; }).IsLoading = false;
                currentFilterItems.forEach(function (item) {
                    if (!item.ItemDisplay) {
                        item.ItemDisplay = "(Blanks)";
                    }
                });
                if (!$event.target.classList.contains("ng-value-icon")) {
                    _this.filterOptions.forEach(function (option) {
                        option.IsDropdownOpen = false;
                    });
                    _this.filterOptions.find(function (x) { return x.FilterField == filterField; }).IsDropdownOpen = true;
                    _this.filterOptions.find(function (x) { return x.FilterField == filterField; }).FilterOptionItems = currentFilterItems;
                }
            });
        }
        else {
            if (!$event.target.classList.contains("ng-value-icon")) {
                this.filterOptions.find(function (x) { return x.FilterField == filterField; }).IsDropdownOpen = !this.filterOptions.find(function (x) { return x.FilterField == filterField; }).IsDropdownOpen;
            }
            else {
                this.filterOptions.forEach(function (option) {
                    option.IsDropdownOpen = false;
                });
                this.filterOptions.find(function (x) { return x.FilterField == filterField; }).IsDropdownOpen = false;
            }
        }
        $event.stopPropagation();
        $event.preventDefault();
    };
    FilteroptionComponent.prototype.onCloseFilterOptions = function () {
        document.querySelectorAll("body").item(0).style.position = "initial";
    };
    FilteroptionComponent.prototype.applyFilterChanges = function () {
        var _this = this;
        var checkedItemsOnly = [];
        this.filterOptions.forEach(function (filterOption) {
            var filteredList = JSON.parse(JSON.stringify(filterOption));
            if (filteredList.FilterOptionItems) {
                filteredList.FilterOptionItems = filteredList.FilterOptionItems.filter(function (x) { return x.IsChecked; });
                if (filteredList.FilterOptionItems.length > 0) {
                    checkedItemsOnly.push(filteredList);
                }
            }
        });
        this.isApplyingFilter = true;
        this.summaryService.changeFilter(this.componentId, checkedItemsOnly).subscribe(function (result) {
            if (result == "1") {
                _this.summaryService.applyFilters(_this.componentId).subscribe(function (applied) {
                    if (applied == "1") {
                        if (_this.modalRef) {
                            _this.applied = true;
                            _this.modalRef.hide();
                        }
                        else {
                            _this.contextMenuService.closeAllContextMenus(null);
                        }
                        _this.refreshSummary.emit(true);
                    }
                    setTimeout(function () {
                        _this.isApplyingFilter = false;
                    }, 1000);
                });
            }
        }, function (error) {
            _this.isApplyingFilter = false;
        });
    };
    FilteroptionComponent.prototype.checkItem = function (filterField, event, filter) {
        var _this = this;
        if (Array.isArray(event)) {
            if (event.length > 0) {
                this.filterOptions.find(function (x) { return x.FilterField == filterField; }).FilterOptionItems.forEach(function (item) {
                    item.IsChecked = false;
                    if (event.filter(function (x) { return x.ItemValue == item.ItemValue; }).length > 0) {
                        item.IsChecked = true;
                    }
                });
            }
            else {
                this.filterOptions.find(function (x) { return x.FilterField == filterField; }).FilterOptionItems.forEach(function (element) {
                    if (element.IsChecked) {
                        element.IsChecked = false;
                    }
                });
            }
            this.hasFilters = false;
            this.filterOptions.forEach(function (option) {
                if (option.HasAdvancedFilter) {
                    _this.hasFilters = true;
                    return;
                }
                if (option.SelectedFilterItem) {
                    if (option.SelectedFilterItem.length > 0) {
                        _this.hasFilters = true;
                        return;
                    }
                }
            });
            // filter.filter(this.currentInput);
        }
    };
    FilteroptionComponent.prototype.mouseEnter = function ($event) {
        if (document.querySelectorAll('.ng-option').item(0)) {
            document.querySelectorAll('.ng-option').item(0).classList.remove("ng-option-marked");
        }
    };
    FilteroptionComponent.prototype.log = function (event) {
        console.log(event);
    };
    FilteroptionComponent.prototype.mouseLeave = function ($event) {
        if ($event.toElement.className == "ng-dropdown-panel-items scroll-host") {
            document.querySelectorAll('.ng-option').item(0).classList.add("ng-option-marked");
        }
    };
    FilteroptionComponent.prototype.input = function (filter, $event) {
        this.currentInput = $event.target.value;
        filter.filter($event.target.value);
    };
    FilteroptionComponent.prototype.openCustomFilter = function (option) {
        var _this = this;
        this.customPopupService.confirm("Custom Filter", option, option.AdvancedFilterValue, ["OK"], option.AdvancedFilterType).subscribe(function (respond) {
            if (respond.answer == 'OK' && respond.respondObject) {
                var param = new Array();
                var filter = new AdvancedFilter();
                filter.FilterField = option.FilterField;
                filter.FilterType = respond.respondObject["filter"];
                filter.FilterValue = respond.respondObject["value"];
                param.push(filter);
                _this.summaryService.AddAdvancedSummaryFilter(_this.componentId, param).subscribe(function (result) {
                    if (result == "1") {
                        _this.popToast("Info", "Custom filter added for " + option.FilterOptionDisplay, "info");
                        _this.hasFilters = true;
                        _this.filterOptions.find(function (x) { return x.FilterField == option.FilterField; }).HasAdvancedFilter = true;
                        _this.filterOptions.find(function (x) { return x.FilterField == option.FilterField; }).AdvancedFilterValue = filter.FilterValue;
                        _this.filterOptions.find(function (x) { return x.FilterField == option.FilterField; }).AdvancedFilterType = filter.FilterType;
                    }
                });
            }
            else if (respond.answer == 'CLEAR' && respond.respondObject) {
                _this.filterOptions.find(function (x) { return x.FilterField == option.FilterField; }).HasAdvancedFilter = false;
                _this.filterOptions.find(function (x) { return x.FilterField == option.FilterField; }).AdvancedFilterValue = "";
                _this.filterOptions.find(function (x) { return x.FilterField == option.FilterField; }).AdvancedFilterType = "";
                _this.clearFilter(option);
            }
        });
    };
    FilteroptionComponent.prototype.clearFilter = function (option) {
        var _this = this;
        this.summaryService.RemoveAdvancedSummaryFilter(this.componentId, option.FilterField).subscribe(function (result) {
            if (result == "1") {
                _this.popToast("Info", "Custom filter removed for " + option.FilterOptionDisplay, "info");
                _this.filterOptions.find(function (x) { return x.FilterField == option.FilterField; }).HasAdvancedFilter = false;
                _this.filterOptions.find(function (x) { return x.FilterField == option.FilterField; }).AdvancedFilterValue = "";
                _this.hasFilters = false;
                _this.filterOptions.forEach(function (option) {
                    if (option.HasAdvancedFilter) {
                        _this.hasFilters = true;
                        return;
                    }
                    if (option.FilterOptionItems) {
                        if (option.FilterOptionItems.filter(function (x) { return x.IsChecked; }).length > 0) {
                            _this.hasFilters = true;
                            return;
                        }
                    }
                });
            }
        });
    };
    FilteroptionComponent.prototype.clearAllFilters = function () {
        var _this = this;
        this.filterOptions.forEach(function (element) {
            element.SelectedFilterItem = [];
            element.AdvancedFilterType = "";
            element.AdvancedFilterValue = "";
            if (element.FilterOptionItems) {
                element.FilterOptionItems.forEach(function (item) {
                    item.IsChecked = false;
                });
            }
        });
        this.summaryService.ClearSummaryFilter(this.componentId).subscribe(function (result) {
            if (result == "1") {
                _this.summaryService.ClearAdvancedSummaryFilter(_this.componentId).subscribe(function (result) {
                    if (result == "1") {
                        _this.hasFilters = false;
                        _this.popToast("Info", "All filters has been cleared", "info");
                        _this.filterOptions.filter(function (x) { return x.HasAdvancedFilter; }).forEach(function (element) {
                            element.HasAdvancedFilter = false;
                        });
                    }
                });
            }
        });
    };
    FilteroptionComponent.prototype.popToast = function (title, body, type) {
        var _this = this;
        var toast = {
            type: type,
            title: title,
            body: body,
            showCloseButton: true,
            bodyOutputType: BodyOutputType.TrustedHtml,
            onShowCallback: function (toast) {
                var toaster = new Toaster();
                toaster.id = toast.toastId;
                toaster.timestamp = Date.now();
                toaster.title = toast.title;
                toaster.content = toast.body;
                _this.toasterMessageService.pushToaster(toaster);
            }
        };
        this.toasterService.pop(toast);
    };
    FilteroptionComponent.prototype.selectAll = function ($event, ctx) {
        if ($event.currentTarget.checked) {
            if (ctx.itemsList.filteredItems.length > 0) {
                ctx.itemsList.filteredItems.forEach(function (item) { return ctx.select(item); });
            }
            else {
                ctx.itemsList.items.forEach(function (item) { return ctx.select(item); });
            }
            ctx.detectChanges();
        }
        else {
            if (ctx.itemsList.filteredItems.length > 0) {
                ctx.itemsList.filteredItems.forEach(function (item) { return ctx.unselect(item); });
            }
            else {
                ctx.itemsList.items.forEach(function (item) { return ctx.unselect(item); });
            }
            ctx.detectChanges();
        }
    };
    FilteroptionComponent.prototype.createNewView = function (parentId) {
        var _this = this;
        if (parentId === void 0) { parentId = '00000000-0000-0000-0000-000000000000'; }
        var viewName = this.viewName;
        var checkedItemsOnly = [];
        this.filterOptions.forEach(function (filterOption) {
            var filteredList = JSON.parse(JSON.stringify(filterOption));
            if (filteredList.FilterOptionItems) {
                filteredList.FilterOptionItems = filteredList.FilterOptionItems.filter(function (x) { return x.IsChecked; });
                if (filteredList.FilterOptionItems.length > 0) {
                    checkedItemsOnly.push(filteredList);
                }
            }
        });
        if (viewName) {
            this.isApplyingFilter = true;
            this.summaryService.changeFilter(this.componentId, checkedItemsOnly).subscribe(function (result) {
                if (result == "1") {
                    _this.summaryService.applyFilters(_this.componentId).subscribe(function (applied) {
                        if (applied == "1") {
                            _this.viewService.createNewView(_this.componentId, viewName, parentId).subscribe(function (result) {
                                if (result == "1") {
                                    _this.hide();
                                }
                                _this.isApplyingFilter = false;
                                _this.viewService.setRefreshView(true);
                            }, function (error) {
                                _this.isApplyingFilter = false;
                            });
                        }
                        else {
                            _this.isApplyingFilter = false;
                        }
                    }, function (error) {
                        _this.isApplyingFilter = false;
                    });
                }
                else {
                    _this.isApplyingFilter = false;
                }
            }, function (error) {
                _this.isApplyingFilter = false;
            });
        }
        else {
            this.isEmptyView = true;
        }
    };
    FilteroptionComponent.prototype.onBlur = function (filterField, $event) {
        if ($event.relatedTarget) {
            if ($event.relatedTarget.className == "checkbox-input" || $event.relatedTarget.className == "custom-input-search") {
            }
            else {
                this.filterOptions.find(function (x) { return x.FilterField == filterField; }).IsDropdownOpen = false;
            }
        }
    };
    FilteroptionComponent.prototype.onBlurInput = function ($event) {
        if ($event.relatedTarget) {
            if ($event.relatedTarget.className == "modal fade show") {
                this.filterOptions.forEach(function (option) {
                    option.IsDropdownOpen = false;
                });
            }
        }
    };
    FilteroptionComponent.prototype.onKeyUp = function (value) {
        this.isEmptyView = false;
        this.viewName = value;
    };
    FilteroptionComponent.prototype.hide = function () {
        this.changeFilter();
        this.modalRef.hide();
    };
    FilteroptionComponent.prototype.onContextMenu = function ($event, customFilter) {
        if ($event.button == 0) {
            this.showFilterAsContextMenu($event, customFilter);
        }
        $event.preventDefault();
        $event.stopPropagation();
    };
    FilteroptionComponent.prototype.ngOnInit = function () {
    };
    return FilteroptionComponent;
}());
export { FilteroptionComponent };
